import React from 'react';
import { css } from '@emotion/react';
import { TRIAL_DAYS } from "../hooks/useStripePlans";

import theme from "../../theme";

type Props = {
    currencySymbol?: string,
};

const OrderSummaryCharge: React.FC<Props> = ({
    currencySymbol,
}) => (
    <div css={containerStyle}>
        <div css={chargeStyle}>
            <div>Today's Charge</div>
            <div css={priceStyle}>{currencySymbol}0.00</div>
        </div>
        <div css={guaranteeStyle}>
            <div>{TRIAL_DAYS}-day free trial</div>
        </div>
    </div>
);

const containerStyle = css`
    height: 78px;
    line-height: 18px;
    padding: 21px 19px 21px 22px;
    font-weight: ${theme.fonts.weights.base};
`;

const chargeStyle = css`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

const guaranteeStyle = css`
    font-size: 12px;
    font-weight: ${theme.fonts.weights.light};
    color: ${theme.colours.grey['650']};
`;

const priceStyle = css`
    font-size: 18px;
`;

export default OrderSummaryCharge;
